import styled from "styled-components";
import { LeftFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { Textfield, SimpleChipItem, PlainTooltip } from "@similarweb/ui-components";
import { colorsPalettes } from "@similarweb/styles";

export const InputStyle = styled(LeftFlexRow)<{ isFocused?: boolean; isDisabled?: boolean }>`
    border: ${({ isFocused = false }) =>
        isFocused ? `1px solid ${colorsPalettes.blue[400]}` : `1px solid ${colorsPalettes.carbon[100]}`};
    border-radius: 3px;
    padding: 8px;
    width: 345px;
    max-height: 136px;
    overflow: auto;
    box-sizing: border-box;
    pointer-events: ${({ isDisabled = false }) => isDisabled && "none"};
    cursor: ${({ isDisabled = false }) => isDisabled && "not-allowed"};
    flex-wrap: wrap;
    margin-top: 3px;
`;

export const StyledTextField = styled(Textfield)<{ shouldShow: boolean; hasPlaceholder: boolean }>`
    height: ${({ shouldShow }) => (shouldShow ? "20px" : 0)};
    width: ${({ hasPlaceholder }) => hasPlaceholder && "230px"};

    .input-container {
        height: 100%;
        padding: 0 8px;
    }
`;

export const StyledChip = styled(SimpleChipItem)<{ isInvalid?: boolean }>`
    width: fit-content;
    border: ${({ isInvalid }) => isInvalid && `1px solid ${colorsPalettes.red[500]}`};
    height: ${({ isInvalid }) => isInvalid && "30px"};

    .SWReactIcons {
        svg path {
            ${({ isInvalid }) =>
                isInvalid &&
                `
                    fill: ${colorsPalettes.red[500]};
                `}
        }
    }
`;

export const StyledToolTip = styled(PlainTooltip)`
    margin-right: 8px;
`;
